import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Product from "./pages/Product";
import Contact from "./pages/Contact";
import About from "./pages/About";
import WaterPolicy from "./applicationprivacypages/waterremover";
import MessageRecover from "./applicationprivacypages/messageRecovery";
import CamScanner from "./applicationprivacypages/CamScanner";
import YouTubePlayer from "./youtubePlayer/youtube_viewsApplication";
import Quiz from "./quiz.json";

function App() {
  return (
    <BrowserRouter>
    <Routes>
        <Route index element={<Home />} />
        <Route path="/home" element={<Home />} /> 
        <Route path="/about" element={<About />} /> 
        <Route path="/contact" element={<Contact />} /> 
        <Route path="/products" element={<Product />} /> 
        <Route path="/quiz" element={<Quiz />} /> 
        <Route path="/youtube" element={<YouTubePlayer />} /> 
        <Route path="/waterremover/privacyPolicy" element={<WaterPolicy/>}/>
        <Route path="/messagerecovery/privacyPolicy" element={<MessageRecover/>}/>
        <Route path="/CamScanner/privacyPolicy" element={<CamScanner/>}/>
    </Routes>
  </BrowserRouter>
  );
}

export default App;
